import { useSelector } from 'react-redux'

import { useCurrentCollectionId } from 'hooks/menu-collections'
import type { MenuHeadersBrandData, MenuHeadersIncludesData } from 'routes/Menu/domains/brand/types'
import { getBasketMenuUuid } from 'selectors/basket'

export const useCollectionHeaders = (
  headers?: MenuHeadersIncludesData[],
  collectionsPerMenu?: MenuHeadersBrandData[],
) => {
  const currentCollectionId = useCurrentCollectionId()
  const menuUuid = useSelector(getBasketMenuUuid)

  if (!headers || !collectionsPerMenu) {
    return null
  }

  const currentMenuCollections =
    collectionsPerMenu && collectionsPerMenu.find((menu) => menu.attributes?.uuid === menuUuid)

  if (!currentMenuCollections) {
    return null
  }

  const collectionBrandRelations = currentMenuCollections.relationships.collections.data

  const collectionBrandRelation = collectionBrandRelations.find(
    (collection) => collection.id === currentCollectionId,
  )

  if (!collectionBrandRelation) {
    return null
  }

  return headers.find((header) => header.id === collectionBrandRelation.header)
}
